import { useNavigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import Seo from "../components/Seo";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Intro from "../components/Intro";
import TwoWays from "../components/TwoWays";
import LaCocina from "../components/LaCocina";
import MenusSection from "../components/MenusSection";
import Edouard from "../components/Edouard";
import GranadaSection from "../components/GranadaSection";
import SazonSection from "../components/SazonSection";
import Testimonials from "../components/Testimonials";
import Gallery from "../components/Gallery";
import ContactSection from "../components/ContactSection";
import { Reveal } from "../components/Reveal";

function CtaBand() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <section data-testid="cta-band" className="grain bg-terra py-20 text-cream md:py-28">
      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center md:px-10">
        <Reveal>
          <h2 className="font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl">{t.ctaBand.title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-5 max-w-xl text-cream/85">{t.ctaBand.text}</p>
        </Reveal>
        <Reveal delay={0.18}>
          <button
            data-testid="cta-band-reservar"
            onClick={() => navigate("/reservas")}
            className="mt-9 rounded-full bg-cream px-9 py-4 text-sm font-medium text-charcoal transition-all duration-300 hover:scale-[1.03] hover:bg-white"
          >
            {t.ctaBand.cta}
          </button>
        </Reveal>
      </div>
    </section>
  );
}

export default function Home() {
  const { t } = useI18n();
  return (
    <>
      <Seo title={t.seo.home.title} description={t.seo.home.description} />
      <Hero />
      <Marquee />
      <Intro />
      <TwoWays />
      <LaCocina />
      <MenusSection />
      <Edouard />
      <GranadaSection />
      <SazonSection />
      <Testimonials />
      <Gallery />
      <CtaBand />
      <ContactSection />
    </>
  );
}
